const AdditionalInfo = () => (
  <div style={{ padding: "4rem", textAlign: "center" }}>
    <h2>Additional Event Information</h2>
    <p>Date, venue, rules, and FAQs will be updated here.</p>
  </div>
);
export default AdditionalInfo;

